
class BrandModel {
    constructor() {
        this.brandNode = document.querySelectorAll('.brand__selector');
        this.modelNode = document.querySelectorAll('.model__selector');
        this.formSubmit = document.getElementById('brandModelSubmit');

        this.rawData = ALERTS.data; // eslint-disable-line
        this.brands = this.rawData.brands;
        this.models = this.rawData.models;
        // this.loadModels();
        this.initEvents();
    }

    initEvents() {
        Array.from(this.brandNode).forEach((node) => {
            node.addEventListener('change', () => {
                Array.from(this.brandNode).forEach((n) => {
                    n.selectedIndex = node.selectedIndex; // eslint-disable-line
                });
                this.buildHomeSearch();
                this.clearModels(node.selectedIndex);
                this.buildOptions(node.value);

                if (!node.classList.contains('alert_brand')) {
                    this.earlySubmit();
                }
            });
        });

        Array.from(this.modelNode).forEach((node) => {
            node.addEventListener('change', () => {
                Array.from(this.modelNode).forEach((n) => {
                    n.selectedIndex = node.selectedIndex; // eslint-disable-line
                });
                this.buildHomeSearch();
                if (!node.classList.contains('alert_modele')) {
                    this.earlySubmit();
                }
            });
        });
    }

    loadModels() {
        if (this.brandNode) {
            const brand = this.brandNode[0];
            if (brand !== '') {
                this.clearModels(brand.selectedIndex);
                this.buildOptions(brand.value);
            }
        }
    }

    buildHomeSearch() { // eslint-disable-line
        if (document.querySelector('.home__search')) {
            const brand = document.querySelector('.brand__selector').value;
            const model = document.querySelector('.model__selector').value;
            const links = document.querySelectorAll('.home__search');

            Array.from(links).forEach((link) => {
                let action = link.getAttribute('data-baseurl');
                if (brand !== '') {
                    action = `${action}${brand}/`;
                }
                if (brand !== '' && model !== '') {
                    action = `${action}${model}/`;
                }

                if (link.classList.contains('more')) {
                    action = `${action}#filters`;
                }

                link.setAttribute('href', action);
            });
        }
    }

    clearModels(index) {
        Array.from(this.modelNode).forEach((n) => {
            if (index === 0) {
                n.disabled = true; // eslint-disable-line
            } else {
                n.disabled = false; // eslint-disable-line
            }
            n.innerHTML = ''; // eslint-disable-line
            n.appendChild(this.buildDefaultOptions());
        });
    }

    buildOptions(constructor) {
        const models = this.models[constructor];
        if (models.length > 0) {
            Array.from(models).forEach((model) => {
                Array.from(this.modelNode).forEach((nodeEl) => {
                    nodeEl.appendChild(this.buildFromTemplate(model));
                });
            });
        }
    }

    buildDefaultOptions() { // eslint-disable-line
        const opt = document.createElement('option');
        // opt.disabled = true;
        opt.selected = true;
        opt.innerHTML = 'Modèle';
        opt.value = '';

        return opt;
    }

    buildFromTemplate(model) { // eslint-disable-line
        const opt = document.createElement('option');
        opt.innerHTML = model.name;
        opt.value = model.slug;

        return opt;
    }

    earlySubmit() {
        if (this.formSubmit) {
            this.formSubmit.click();
        }
    }
}

export default BrandModel;
